/**
 * The `?redirect=` target from a query string, if it is a same-origin app
 * path - "/x", but never "//evil.com", "/\evil.com" or "https://...", any of
 * which would make the sign-in pages an open redirect. Otherwise null.
 */
export const getSafeRedirect = (search: string): string | null => {
  const redirect = new URLSearchParams(search).get('redirect');
  if (typeof redirect !== 'string') return null;
  const target = redirect.trim();
  if (!target.startsWith('/') || target.startsWith('//') || target.startsWith('/\\')) {
    return null;
  }
  // Control characters (a tab or newline after the slash) are stripped by
  // URL parsers, which turns "/\t/evil.com" into "//evil.com".
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001F\u007F]/.test(target)) return null;
  return target;
};
